import React, { useEffect, useState} from 'react'
import {Accordion, Button, Card, Col, FloatingLabel, Form, FormControl, Row} from 'react-bootstrap'
import {AccordionEventKey, AccordionSelectCallback} from 'react-bootstrap/esm/AccordionContext'
import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import moment from 'moment'
import { getAppointmentDetailsByAppointmentId, saveAppointmentDetails } from '../../../../Adaptor/TUBSIS/controllers/AppointmentDetails/AppointmentDetails'
import { GetAppointmentDetailsOutput } from '../../../../Adaptor/TUBSIS/controllers/AppointmentDetails/models/GetAppointmentDetailsModels'
import PatientAppointmentFNBTQuestions from './PatientAppointmentFNBTQuestions'
import PatientAppointmentWEMIOOQuestions from './PatientAppointmentWEMIOOQuestions'
import PatientAppointmentCOQuestions from './PatientAppointmentCOQuestions'
import { getAppointmentQuestionsByAppointmentId } from '../../../../Adaptor/TUBSIS/controllers/AppointmentQuestions/AppointmentQuestions'
import { GetAppointmentQuestionOutput } from '../../../../Adaptor/TUBSIS/controllers/AppointmentQuestions/models/getAppointmentQuestionsModels'

type Props = { appointment: GetAppointmentByIdOutput }

const PatientAppointmentDetail : React.FC<Props>=({ appointment }) => {

  const [activeAccordion, setActiveAccordion] = useState<AccordionEventKey | null>(null)

  const toggleAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
    setActiveAccordion(eventKey === activeAccordion ? null : eventKey)
  }

  const [appointmentId, setAppointmentId] = useState<number | null>(null)
  const [appointmentDate, setAppointmentDate] = useState<Date>()
  const [isFirstAppointment, setIsFirstAppointment] = useState<boolean | null>(null)
  const [patientWasHere, setPatientWasHere] = useState<boolean | null>(null)
  //const [haveYouSmokeRecently, setHaveYouSmokeRecently] = useState<number | null>(null)
  const [dailySmokingCount, setDailySmokingCount] = useState<string | null>(null)
  const [weight, setWeight] = useState<string | null>(null)
  const [coMeasurement, setCOMeasurement] = useState<string | null>(null)
  const [appliedMedicationNRT, setAppliedMedicationNRT] = useState<boolean | null>(null);
  const [appliedMedicationBupropion, setAppliedMedicationBupropion] = useState<boolean | null>(null);
  const [appliedMedicationCytisine, setAppliedMedicationCytisine] = useState<boolean | null>(null);
  const [appliedMedicationVareniklin, setAppliedMedicationVareniklin] = useState<boolean | null>(null);
  const [appliedMedicationDesc, setAppliedMedicationDesc] = useState<string | null>(null);
  const [notes, setNotes] = useState<string | null>(null);

  const [isValidWeight, setIsValidWeight] = useState<boolean>(true);
  const [isValidDailySmokingCount, setIsValidDailySmokingCount] = useState<boolean>(true);

  const [appointmentDetails, setAppointmentDetails] = useState<GetAppointmentDetailsOutput | null>(null)
  const [appointmentQuestions, setAppointmentQuestions] = useState<GetAppointmentQuestionOutput[]>([])
  const [loading, setLoading] = useState(true); 
  useEffect(() => {
    if (appointment && appointment.appointmentId > 0) {
      getAppointmentQuestionsByAppointmentId(appointment.appointmentId)
      .then((response) => {
        // console.log("burada", JSON.stringify(response))
          if (response && response.data !== null) {
            setAppointmentQuestions(response.data)
            setLoading(false); // Verilerin yüklendiğini işaretle
          }
      })
      .catch((error) => {
          console.error("Error fetching user:", error);
      });
    }
  }, [appointment])
  
  useEffect(() => {
    if (appointment && appointment.appointmentId > 0) {
      getAppointmentDetailsByAppointmentId(appointment.appointmentId)
        .then((response) => {

          setAppointmentDetails(response.data)

          setAppointmentId(appointment.appointmentId)
          setAppointmentDate(appointment.appointmentStartDate)
          setIsFirstAppointment(appointment.isFirstAppointment)
          setPatientWasHere(appointment.patientWasHere)

          //setHaveYouSmokeRecently(response.data?.haveYouSmokeRecently ?? 26000)
          setDailySmokingCount(!response.data?.dailySmokingCount ||  response.data?.dailySmokingCount === 0 ? '' : response.data?.dailySmokingCount.toString())
          setWeight(!response.data?.weight || response.data?.weight === 0 ? '' : response.data?.weight.toString())
          setCOMeasurement(response.data?.coMeasurement ?? '')
          setAppliedMedicationNRT(response.data?.appliedMedicationNRT ?? false)
          setAppliedMedicationBupropion(response.data?.appliedMedicationBupropion ?? false)
          setAppliedMedicationCytisine(response.data?.appliedMedicationCytisine ?? false)
          setAppliedMedicationVareniklin(response.data?.appliedMedicationVareniklin ?? false)
          setAppliedMedicationDesc(response.data?.appliedMedicationDesc ?? '')
          setNotes(response.data?.notes ?? '')

        })
        .catch((error) => {
          console.error("Error fetching user:", error);
        });
    }
  }, [appointment])

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  const handleItemChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === 'weight') {
      // const pattern = /^\d*$/;//doğal sayı regexi
      const pattern = /^(\d+)?(\.\d{1,2})?$/;//en fazla 2 ondalık bulunduran sayı regexi
      // console.log("test", pattern.test(value), value)
      setIsValidWeight(pattern.test(value));
      setWeight(value);
    } /*else if (name === 'haveYouSmokeRecently') {
      setHaveYouSmokeRecently(parseInt(value));
    }*/ else if (name === 'coMeasurement') {
      setCOMeasurement(value);
    } else if (name === 'dailySmokingCount') {
      const pattern = /^(0|[1-9][0-9]*)$/;
      if (pattern.test(value) === false && value.trim() === '') {
        setIsValidDailySmokingCount(true)
      } else {
        setIsValidDailySmokingCount(pattern.test(value))
      }
      setDailySmokingCount(value);
    } else if (name === 'appliedMedicationDesc') {
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
      setAppliedMedicationDesc(value);
    } else if (name === 'notes') {
      setNotes(value)
      e.target.style.height = 'auto'; // Yüksekliği otomatik ayarla
      e.target.style.height = (e.target.scrollHeight) + 'px'; // Scroll yüksekliğini ayarla
    }
  };

  const handleCheckBoxItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked, type } = e.target;
    if (type === 'checkbox' && name === 'patientWasHere') {
      setPatientWasHere(checked);      
    } else if (type === 'checkbox' && name === 'appliedMedicationNRT') {
      setAppliedMedicationNRT(checked);      
    } else if (type === 'checkbox' && name === 'appliedMedicationBupropion') {
      setAppliedMedicationBupropion(checked);
    } else if (type === 'checkbox' && name === 'appliedMedicationCytisine') {
      setAppliedMedicationCytisine(checked);
    } else if (type === 'checkbox' && name === 'appliedMedicationVareniklin') {
      setAppliedMedicationVareniklin(checked);
    }
};

  const handleUpdate = async () => {
    // Form verilerini güncellemek için gerekli işlemleri burada gerçekleştirin
    // console.log("Form verileri güncellendi:", userData);

    if (!appointmentId) {
      alert("Randevu bilgilerine ulaşılamadı. Bilgiler kaydedilemedi.")
      return;
    }

    if (!isValidWeight || !isValidDailySmokingCount) {
      return;
    }

    const requestModel = {
      appointmentId: appointmentId,
      weight: parseFloat(weight??''),
      coMeasurement: coMeasurement??'',
      //haveYouSmokeRecently: haveYouSmokeRecently??26000,
      dailySmokingCount: parseInt(dailySmokingCount??''),
      appliedMedicationNRT: appliedMedicationNRT??false,
      appliedMedicationBupropion: appliedMedicationBupropion??false,
      appliedMedicationCytisine: appliedMedicationCytisine??false,
      appliedMedicationVareniklin: appliedMedicationVareniklin??false,
      appliedMedicationDesc: appliedMedicationDesc,
      notes: notes,
      patientWasHere: patientWasHere??false,
    }

    var response = await saveAppointmentDetails(requestModel)

    if (response.success) {
      alert(response.message)      
    } else {
      alert("Randevu bilgileri kaydedilirken bir sorun oluştu: " + response.message)
    }

    // window.location.reload()
  }
  return (
    <Accordion activeKey={activeAccordion} onSelect={toggleAccordion}>
      <Card key={1}>
        <Card.Header style={patientWasHere
    ? { backgroundColor: '#A5D6A7' }
    : (
      appointmentDate &&
      new Date(appointmentDate).getDate() === new Date().getDate() &&
      new Date(appointmentDate).getMonth() === new Date().getMonth() &&
      new Date(appointmentDate).getFullYear() === new Date().getFullYear()
        ? { backgroundColor: '#FFD180' }
        : { backgroundColor: '#FFCDD2' }
    )}>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <Button
              className='d-flex justify-content-between align-items-center w-100'
              variant='link'
              onClick={(e) => toggleAccordion(appointmentId ? appointmentId.toString() : 'index.toString()', e)}
            >
              <div className='text-left text-gray-700'>{moment(appointmentDate).format("DD MMMM YYYY HH:mm")}</div>
              <div className='text-left text-gray-700'>{isFirstAppointment ? "İLK RANDEVU" : "KONTROL"}</div>
            </Button>
          </div>
        </Card.Header>
        <Accordion.Collapse eventKey={appointmentId ? appointmentId.toString() : 'index.toString()'}>
          <Card.Body>
            <Form onSubmit={handleUpdate}>

              <Row className='mb-3'>
                <Form.Group as={Col} 
                  style={{
                    border: "2px solid #ced4da", // Sınır rengi
                    borderRadius: "0.25rem", // Köşelerin yuvarlatılması
                    padding: "0.5rem", // Kenar boşluğu
                    display: "flex", // İçeriği bir araya getirmek için flex kullan
                    flexDirection: "row-reverse", // İçeriği ters yönde sırala (sağdan sola)
                    marginLeft: "10px", // Sol kenar boşluğu
                    justifyContent: "center" // İçeriği yatayda merkezle
                  }}>
                  <Form.Check 
                    type='checkbox' 
                    id='patientWasHere'
                    name='patientWasHere' 
                    label='Randevuya Geldi Mi' 
                    className='me-2 mb-2 mt-2' 
                    checked={patientWasHere??false}
                    onChange={handleCheckBoxItemChange}/>
                </Form.Group>
                <Form.Group as={Col}></Form.Group>
                <Form.Group as={Col}></Form.Group>
                <Form.Group as={Col}></Form.Group>
              </Row>
              <Row className='mb-4'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='weight' label='Kilo'>
                    <FormControl
                      type='text'
                      name='weight'
                      value={weight ?? ''}
                      isInvalid={!isValidWeight}
                      onChange={handleItemChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Lütfen geçerli bir sayı giriniz.
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>
                {/* <Form.Group as={Col}></Form.Group> */}
         
                <Form.Group as={Col}>
                  <FloatingLabel
                    controlId='dailySmokingCount'
                    label='Günde Kaç Adet Sigara İçiyorsun?'
                  >
                    <Form.Control
                      type='text'
                      name='dailySmokingCount'
                      isInvalid={!isValidDailySmokingCount}
                      value={dailySmokingCount ?? ''}
                      onChange={handleItemChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Lütfen geçerli bir sayı giriniz.
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>

                <Form.Group as={Col}>
                  <FloatingLabel controlId='coMeasurement' label='CO Değeri'>
                    <FormControl
                      type='text'
                      name='coMeasurement'
                      value={coMeasurement??''}
                      onChange={handleItemChange}
                    />
                  </FloatingLabel>
                </Form.Group>

                {/* <Form.Group as={Col}>
                  <FloatingLabel controlId='haveYouSmokeRecently' label='Yakın Zamanda Sigara İçtiniz Mi?'>
                    <Form.Select
                      // className='mt-2'
                      name='haveYouSmokeRecently'
                      value={haveYouSmokeRecently??26000}
                      onChange={handleItemChange}
                    >
                      <option value='26000'>Seçiniz</option>
                      <option value='26001'>Evet ve bırakmayı düşünmüyorum</option>
                      <option value='26002'>Evet ama bırakmayı düşünüyorum</option>
                      <option value='26003'>Evet, ama ciddi olarak bırakmaya niyetliyim</option>
                      <option value='26004'>Hayır, sigarayı çoktan bıraktım</option>
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group> */}
              </Row>

              <Row className='mb-3'>
                <Form.Group as={Col}>
                  <Form.Label className='text-gray-500'>Verilen Tedavi</Form.Label>
                  <Form.Group>
                    <Form.Check
                      type='checkbox'
                      checked={appliedMedicationNRT??false}
                      id='appliedMedicationNRT'
                      name='appliedMedicationNRT'
                      label='NRT'
                      className='mb-2'
                      onChange={handleCheckBoxItemChange}
                    />
                    <Form.Check
                      type='checkbox'
                      checked={appliedMedicationBupropion??false}
                      id='appliedMedicationBupropion'
                      name='appliedMedicationBupropion'
                      label='Bupropion'
                      className='mb-2'
                      onChange={handleCheckBoxItemChange}
                    />
                    <Form.Check
                      type='checkbox'
                      checked={appliedMedicationVareniklin??false}
                      id='appliedMedicationVareniklin'
                      name='appliedMedicationVareniklin'
                      label='Vareniklin'
                      className='mb-2'
                      onChange={handleCheckBoxItemChange}
                    />
                    <Form.Check
                      type='checkbox'
                      checked={appliedMedicationCytisine??false}
                      id='appliedMedicationCytisine'
                      name='appliedMedicationCytisine'
                      label='Cytisine'
                      className='mb-2'
                      onChange={handleCheckBoxItemChange}
                    />

                    <Form.Control
                      className='mb-3'
                      value={appliedMedicationDesc??''}
                      id='appliedMedicationDesc'
                      name='appliedMedicationDesc'
                      type='textarea'
                      as='textarea'
                      placeholder='Başka varsa lütfen belirtiniz...'
                      style={{ width: '350px' }}
                      onChange={handleItemChange}
                    />

                  </Form.Group>
                  <Form.Group as={Col}></Form.Group>
                </Form.Group>
              </Row>

              <Row className='mb-5'>
                <Form.Group as={Col}>
                  <FloatingLabel controlId='notes' label='NOTLAR'>
                    <FormControl
                      type='textarea'
                      as="textarea"
                      value={notes??''}
                      name='notes'
                      onChange={handleItemChange}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Row>

              <Row className='mb-3'>
                <PatientAppointmentCOQuestions appointment={appointment}/>
              </Row>
              <Row className='mb-3'>
                <PatientAppointmentFNBTQuestions appointment={appointment} propAppointmentQuestions={appointmentQuestions}/>
              </Row>
              <Row className='mb-3'>
                <PatientAppointmentWEMIOOQuestions appointment={appointment} propAppointmentQuestions={appointmentQuestions}/>
              </Row>

              <Row className='mb-3 mt-5'>
                <Form.Group as={Col}>
                  <Button variant='primary' onClick={handleUpdate}>
                    Kaydet
                  </Button>
                </Form.Group>
              </Row>
            </Form>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
}

export default PatientAppointmentDetail
